/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const k = require('@gral/constants');
const act = require('@flux/actions/actView');
const moment = require('moment');

module.exports = {
  UNSAFE_componentWillMount() {
    this._myNeeds = [];
    this._requested = [];
  },

  componentWillUnmount() {
    this._myNeeds = [];
    this._requested = [];
  },
  // Needs have:
  // - Reource url [mandatory]
  // - Datapath [mandatory]

  componentDidMount() {
    return this._myNeedsHandle();
  },
  componentDidUpdate(prevProps, prevState) {
    return this._myNeedsHandle();
  },

  _myNeedsHandle() {
    const pending = [];
    for (const need of Array.from(this._myNeeds)) {
      const rsrc = this.props.data.get(need.dataPath);

      if (rsrc == null && _.indexOf(this._requested, need.dataPath) === -1) {
        pending.push(need);
        this._requested.push(need.dataPath);
        continue;
      }

      if (rsrc != null) {
        if (
          !rsrc.get('state') === k.rsrcStates.SYNCING ||
          (rsrc.get('fStale') && rsrc.get('state') === k.rsrcStates.IDLE && rsrc.get('errors').size === 0) ||
          (need.refreshPeriod &&
            moment().subtract(need.refreshPeriod, 'seconds') > moment(rsrc.get('date')) &&
            rsrc.get('state') === k.rsrcStates.IDLE &&
            rsrc.get('errors').size === 0)
        ) {
          pending.push(need);
          continue;
        }
      }
    }

    if (pending.length) {
      return act.fetchMultiple(pending);
    }
  },

  iNeed(need) {
    // # {url, dataPath, retryPeriod, refreshPeriod} = need
    if (_.find(this._myNeeds, o => o.dataPath === need.dataPath)) {
      return;
    }
    return this._myNeeds.push(need);
  },

  iDontNeed(need) {
    const myNeedIndex = _.findIndex(this._myNeeds, o => o.dataPath === need.dataPath);
    if (myNeedIndex > -1) {
      this._myNeeds.splice(myNeedIndex, 1);
    }
    const myRequestedIndex = _.indexOf(this._requested, need.dataPath);
    if (myRequestedIndex > -1) {
      this._requested.splice(myNeedIndex, 1);
    }
    return act.markAsStale(need.dataPath);
  },
};
